import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import TechHero from './components/TechHero';
import TechPainPoints from './components/TechPainPoints';
import TechPrinciple from './components/TechPrinciple';
import TechProcess from './components/TechProcess';
import TechAdvantages from './components/TechAdvantages';
import TechCTA from './components/TechCTA';

export default function Technology() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '核心技術｜PQernel® 奈米擴鏈補強劑 — 聚量應用材料廢棄塑膠再生技術',
      en: 'Core Technology | PQernel® Nano Chain Extender — PolyQ Applied Materials Plastic Waste Recycling Technology',
      ja: 'コア技術 | PQernel® ナノ鎖延長補強剤 — 聚量応用材料廃プラスチック再生技術',
    },
    description: {
      zh: 'PQernel® 奈米擴鏈補強劑，可直接添加於廢棄塑膠，提升再生塑料物性與加工穩定性，支援循環經濟與低碳材料導入。',
      en: 'PQernel® nano chain extender can be directly added to waste plastics, improving recycled plastic properties and processing stability, supporting circular economy and low-carbon material adoption.',
      ja: 'PQernel®ナノ鎖延長補強剤は廃プラスチックに直接添加でき、再生プラスチックの物性と加工安定性を向上させ、サーキュラーエコノミーと低炭素材料の導入をサポートします。',
    },
    keywords: {
      zh: 'PQernel, 奈米擴鏈補強劑, PQMB, 廢棄塑膠再生技術, 高分子鏈修復, 分子量補足, 相容性改善, 循環經濟, 低碳材料, 聚量應用材料',
      en: 'PQernel, nano chain extender, PQMB, plastic waste recycling technology, polymer chain repair, molecular weight restoration, compatibility improvement, circular economy, low-carbon materials, PolyQ Applied Materials',
      ja: 'PQernel, ナノ鎖延長補強剤, PQMB, 廃プラスチック再生技術, 高分子鎖修復, 分子量補充, 相容性改善, サーキュラーエコノミー, 低炭素材料, 聚量応用材料',
    },
    path: '/technology',
    jsonLd: {
      '@type': 'WebPage',
      name: (lang === 'en'
        ? 'Core Technology | PQernel® Nano Chain Extender'
        : lang === 'ja'
          ? 'コア技術 | PQernel® ナノ鎖延長補強剤'
          : '核心技術｜PQernel® 奈米擴鏈補強劑'),
      url: (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL || 'https://www.juuliang.com') + '/technology',
      description: (lang === 'en'
        ? 'PQernel® nano chain extender directly added to waste plastics to improve recycled plastic properties and processing stability.'
        : lang === 'ja'
          ? 'PQernel®ナノ鎖延長補強剤は廃プラスチックに直接添加でき、再生プラスチックの物性と加工安定性を向上させます。'
          : 'PQernel® 奈米擴鏈補強劑，可直接添加於廢棄塑膠，提升再生塑料物性與加工穩定性。'),
    },
  });

  return (
    <PageLayout>
      <TechHero />
      <TechPainPoints />
      <TechPrinciple />
      <TechProcess />
      <TechAdvantages />
      <TechCTA />
    </PageLayout>
  );
}